import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  FaBars,
  FaTimes,
  FaUsers,
  FaBox,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaFileInvoice,
  FaQuoteLeft,
  FaChartLine,
  FaUserTie,
  FaSignOutAlt,
  FaHome,
  FaUndo
} from 'react-icons/fa';
import logo from '../../assets/img.jpg';
import './MobileAdminNav.css';

const MobileAdminNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Handle touch gestures for mobile
  const handleTouchStart = (e) => {
    const startX = e.touches[0].clientX;
    const startY = e.touches[0].clientY;

    const handleTouchMove = (e) => {
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const diffX = startX - currentX;
      const diffY = startY - currentY;

      // If swiping right (closing gesture) and not swiping vertically much
      if (diffX > 50 && Math.abs(diffY) < 100) {
        closeMenu();
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      }
    };

    const handleTouchEnd = () => {
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };

    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
  };

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const menuItems = [
    { path: '/adminavsbusiness.com', icon: FaHome, label: 'Dashboard' },
    { path: '/adminavsbusiness.com/companies', icon: FaBuilding, label: 'Companies' },
    { path: '/adminavsbusiness.com/vendors', icon: FaTruck, label: 'Vendors' },
    { path: '/adminavsbusiness.com/inventory', icon: FaBox, label: 'Inventory' },
    { path: '/adminavsbusiness.com/billing', icon: FaFileInvoice, label: 'Billing' },
    { path: '/adminavsbusiness.com/quotations', icon: FaQuoteLeft, label: 'Quotations' },
    { path: '/adminavsbusiness.com/returns', icon: FaUndo, label: 'Return Product' },
    { path: '/adminavsbusiness.com/accounts', icon: FaChartLine, label: 'Accounts' },
    { path: '/adminavsbusiness.com/accounts-ledger', icon: FaChartLine, label: 'Accounts Ledger' },
    { path: '/adminavsbusiness.com/client-ledger', icon: FaChartLine, label: 'Client Ledger' },
    { path: '/adminavsbusiness.com/customers', icon: FaUserTie, label: 'Customers' },
    { path: '/adminavsbusiness.com/users', icon: FaUsers, label: 'Users' }
  ];

  return (
    <>
      {/* Mobile Header */}
      <header className="mobile-admin-header">
        <div className="mobile-header-content">
          <div className="mobile-logo">
            <img src={logo} alt="AVS Business Logo" className="mobile-menu-logo" />
          </div>
          <button
            className="mobile-menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMenu}>
          <div
            className="mobile-menu"
            onClick={e => e.stopPropagation()}
            onTouchStart={handleTouchStart}
          >
            <div className="mobile-menu-header">
              <img src={logo} alt="AVS Business Logo" className="mobile-menu-logo" />
              <h3>Admin Menu</h3>
              <button
                className="mobile-menu-close"
                onClick={closeMenu}
                aria-label="Close menu"
              >
                <FaTimes />
              </button>
            </div>

            <nav className="mobile-menu-nav">
              <ul className="mobile-menu-list">
                {menuItems.map((item) => {
                  const IconComponent = item.icon;
                  return (
                    <li key={item.path} className="mobile-menu-item">
                      <Link
                        to={item.path}
                        className={`mobile-menu-link ${location.pathname === item.path ? 'active' : ''}`}
                        onClick={closeMenu}
                      >
                        <IconComponent className="mobile-menu-icon" />
                        <span className="mobile-menu-text">{item.label}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>

            <div className="mobile-menu-footer">
              <button
                onClick={handleLogout}
                className="mobile-logout-button"
              >
                <FaSignOutAlt className="mobile-logout-icon" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileAdminNav;